export const hasActiveFilterValue = (value: unknown): boolean => {
  if (value == null) return false;

  if (value instanceof Date) {
    return !Number.isNaN(value.getTime());
  }

  if (Array.isArray(value)) {
    return value.some(hasActiveFilterValue);
  }

  // An unchecked feature (false) is no active filter
  if (typeof value === 'boolean') {
    return value;
  }

  if (typeof value === 'number') {
    return Number.isFinite(value);
  }

  if (typeof value === 'string') {
    return value.trim().length > 0;
  }

  if (typeof value === 'object') {
    return Object.values(value).some(hasActiveFilterValue);
  }

  return false;
};
